// extracted by mini-css-extract-plugin
export var backgroundContainmentImage = "HeroSectionChampionship-module--backgroundContainmentImage--40f8b";
export var backgroundImage = "HeroSectionChampionship-module--backgroundImage--fbae7";
export var championshipLogo = "HeroSectionChampionship-module--championshipLogo--85c25";
export var content = "HeroSectionChampionship-module--content--0f831";
export var information = "HeroSectionChampionship-module--information--eaa0f";
export var naming = "HeroSectionChampionship-module--naming--6690a";
export var wrapper = "HeroSectionChampionship-module--wrapper--262a3";